import Message from './h-message/index'
import Confirm from './h-confirm/index'

const install = function (Vue) {
  if (install.installed) {
    return
  }

  Vue.$confirm = Vue.prototype.$confirm = Confirm.show
  Vue.$message = Vue.prototype.$message = Message.show
  Vue.$hideMessage = Vue.prototype.$hideMessage = Message.hide
}

export default {
  install,
  Message,
}
